/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_Group_NavigateInputs */

const en_palette_group_navigate = /** @type {(inputs: Palette_Group_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigate`)
};

const de_palette_group_navigate = /** @type {(inputs: Palette_Group_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation`)
};

/**
* | output |
* | --- |
* | "Navigate" |
*
* @param {Palette_Group_NavigateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const palette_group_navigate = /** @type {((inputs?: Palette_Group_NavigateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_Group_NavigateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_palette_group_navigate(inputs)
	return en_palette_group_navigate(inputs)
});